jQuery(document).ready(function($) {
  /* Announcement Bar */
  if($('.announcement-bar').length) {
    const $marqueeInner = $('.announcement-bar .announcement-bar__message');
    const text = $marqueeInner.find('p:first').text();
    const $container = $('.announcement-bar .announcement-bar__item');
    const containerWidth = $container.width();
    const textWidth = $marqueeInner.find('p:first').outerWidth(true);
    const repeatCount = Math.ceil(containerWidth / textWidth) + 2; // Add buffer

    for (let i = 1; i < repeatCount; i++) {
      $marqueeInner.append(`<p>${text}</p>`);
    }

    $('.announcement-bar').css('opacity', 1);  
  }

  /* Scrolling Text Divider */
  if($('.marquee').length) {
    const $marqueeInner = $('.marquee__inner');
    const text = $marqueeInner.find('p:first').html();
    const textEl = $marqueeInner.find('p:first');
    const containerWidth = $marqueeInner.width();
    const textWidth = $marqueeInner.find('p:first').outerWidth(true);
    const repeatCount = Math.ceil(containerWidth / textWidth) + 2; // Add buffer

    textEl.text('');
    for (let i = 1; i < repeatCount; i++) {
      textEl.append(text);
    }

    $('.marquee').css('opacity', 1);
  }

  const items = document.querySelectorAll('image-with-text-item.no-img');

  if (items.length > 0) {
    items.forEach(function(item) {
      const contentWrapper = item.closest('.image-with-text__content-wrapper');
      const outerWrapper = item.closest('.image-with-text__wrapper');
      if (contentWrapper) {
        contentWrapper.classList.add('no-img');
      }
      if (outerWrapper) {
        outerWrapper.classList.add('no-img');
      }
    });
  }

  const checkoutButton = document.querySelector('#boxi-root button[class*="_checkoutButton_"]');

  if (checkoutButton && document.body.classList.contains('preorders-closed')) {
    checkoutButton.textContent = 'Pre-orders Closed';
    checkoutButton.classList.add('disabled');
  }

});
